import {
  LeftOutlined,
  RightOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
} from '@ant-design/icons';
import { Button, Row } from 'antd';
import React from 'react';

type TProps = {
  slide: any;
  slides: any;
  onPrevClick: () => void;
  onNextClick: () => void;
  onMoveLeft: () => void;
  onMoveRight: () => void;
};
export const GalleryCounter: React.FC<TProps> = ({
  slide,
  slides,
  onPrevClick,
  onNextClick,
  onMoveLeft,
  onMoveRight,
}) => {
  return (
    <Row align='middle' justify='center' style={{ gap: '8px' }}>
      <Button icon={<DoubleLeftOutlined />} size='large' onClick={onMoveLeft} />
      <Button icon={<LeftOutlined />} size='large' onClick={onPrevClick} />
      <div style={{ margin: '0 16px' }}>
        {slide}/{slides}
      </div>
      <Button icon={<RightOutlined />} size='large' onClick={onNextClick} />
      <Button
        icon={<DoubleRightOutlined />}
        size='large'
        onClick={onMoveRight}
      />
    </Row>
  );
};
